import React, { useState } from "react";
import { PenSquare } from "lucide-react";
import { Modal } from "./Modal";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";

function Field({ label, hint, children }) {
  return (
    <label style={{ display: "block", marginBottom: 10 }}>
      <span style={{ display: "block", fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--text-3)", marginBottom: 4 }}>
        {label}
      </span>
      {children}
      {hint && <span style={{ fontSize: 11, color: "var(--text-3)", marginTop: 3, display: "block" }}>{hint}</span>}
    </label>
  );
}

/**
 * SPT-PTE-2026-0062 follow-up — Heike wanted to select several equipment
 * lines on a job at once and apply the SAME Sage Quote Number and/or PO
 * Received date to all of them in one go, instead of editing each line's
 * pencil-icon individually. Leaves every other field (status, payment,
 * purchase_order) untouched.
 */
export function BulkQuotePoModal({ itemIds, onClose, onDone }) {
  const [quoteNumber, setQuoteNumber] = useState("");
  const [poDate, setPoDate] = useState("");
  const [busy, setBusy] = useState(false);
  const valid = quoteNumber.trim() || poDate;

  const submit = async () => {
    if (!valid) return;
    setBusy(true);
    try {
      const payload = { item_ids: itemIds };
      if (quoteNumber.trim()) payload.quote_number = quoteNumber.trim();
      if (poDate) payload.po_date = poDate;
      const r = await api.post("/job-items/bulk-quote-po", payload);
      if (r.data.skipped?.length) toast.warning(`${r.data.count} updated · ${r.data.skipped.length} skipped (see audit log)`);
      else toast.success(`${r.data.count} line(s) updated`);
      onDone && onDone();
      onClose && onClose();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <Modal open onClose={onClose} icon={PenSquare}
      title={`Edit Quote # / PO Received — ${itemIds.length} line(s)`}
      subtitle="Applies the value(s) below to every selected equipment line. Leave a field blank to leave it unchanged."
      footer={
        <>
          <button className="btn ghost" onClick={onClose} disabled={busy} data-testid="bulk-quote-po-cancel">Cancel</button>
          <button className="btn gold" onClick={submit} disabled={!valid || busy} data-testid="bulk-quote-po-submit">
            <PenSquare size={13} /> {busy ? "Saving…" : `Apply to ${itemIds.length} line(s)`}
          </button>
        </>
      }
    >
      <Field label="Quote number" hint="Sage Quote Number / Reference — leave blank to not change it.">
        <input className="input mono" value={quoteNumber}
          onChange={(e) => setQuoteNumber(e.target.value)}
          placeholder="e.g. QT-24791" data-testid="bulk-quote-po-quote" />
      </Field>
      <Field label="PO Received date" hint="Leave blank to not change it.">
        <input type="date" className="input" value={poDate}
          onChange={(e) => setPoDate(e.target.value)}
          data-testid="bulk-quote-po-date" />
      </Field>
    </Modal>
  );
}
